<form [formGroup]='formEditValue' (submit)='onSubmit()' novalidate>
  <div class="modal-header">
    <div class="modal-header-content">
      <h1 class="modal-title" *ngIf="title">{{title}}</h1>
      <h2 class="modal-subtitle" *ngIf="subtitle">{{subtitle}}</h2>
    </div>
    <i class="ic-close icon-size-32" (click)="activeModal.close()"></i>
  </div>
  <div class="modal-body">
    <div class="form-container">
      <div class="form-group">
        <label
          for='name'
          class="input-title"
          *ngIf="inputLabel"
          [class.text-error]="submitted && form.inputValue.invalid"
        >{{inputLabel}}</label>
        <input
          id="name"
          formControlName="inputValue"
          class="form-control"
          type="text"
          placeholder="Insert value"
          [class.is-invalid]="submitted && form.inputValue.invalid"
          ngbAutofocus
        >
        <small class="invalid-feedback text-error" *ngIf="form.inputValue.errors && submitted">
          <span *ngIf="form.inputValue.errors.required">Value is mandatory. Please fill the field!</span>
          <span *ngIf="form.inputValue.errors.pattern">Insert a value equal to or greater than 0</span>
        </small>
      </div>
    </div>
  </div>
  <div class="modal-footer pt-5">
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close()">Cancel</button>
    <button class="btn btn-default ml-3" [ngClass]="{'btn-disabled disabled': validation}" type='submit'>Save</button>
  </div>
</form>